import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { GraduationCapIcon, MenuIcon, XIcon, ChevronDownIcon } from 'lucide-react';
import { degreeCategories } from '../data/degrees';
export function Header() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const popularPrograms = [{
    name: 'Business',
    path: '/degrees/business'
  }, {
    name: 'Computer Science',
    path: '/degrees/computer-science'
  }, {
    name: 'Nursing',
    path: '/degrees/healthcare'
  }, {
    name: 'Criminal Justice',
    path: '/degrees/criminal-justice'
  }, {
    name: 'Psychology',
    path: '/degrees/psychology'
  }];
  return <header className="bg-surface border-b border-hairline sticky top-0 z-50" data-id="element-285" data-mp="36a0dhhc67iv9">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-286" data-mp="3baocap6n5401">
        <div className="flex justify-between items-center h-14 md:h-20" data-id="element-287" data-mp="3b8blrnmthlbd">
          {/* Logo */}
          <div className="flex-shrink-0 flex items-center" data-id="element-288" data-mp="3f9nbru9ls8k3">
            <Link to="/" className="flex items-center" data-id="element-289" data-mp="2wlm8ne6n24jw">
              <img src="https://cdn.magicpatterns.com/uploads/98gXraqnTFT6vsk8BtTnBr/FOC_Logo_(1).png" alt="findonlinecollege.com" className="h-8 md:h-11 w-auto object-contain" data-id="element-290" data-mp="2rlrkvji5tv32" />
            </Link>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8" data-id="element-291" data-mp="2hovfhmnk5p2q">
            <div className="relative" onMouseEnter={() => setIsDropdownOpen(true)} onMouseLeave={() => setIsDropdownOpen(false)} data-id="element-292" data-mp="3fbvjtdkel6nq">
              

              {/* Dropdown Menu */}
              {isDropdownOpen && <div className="absolute top-full left-0 w-64 bg-surface shadow-ds-lg rounded-b-2xl border border-hairline py-2 z-50" data-id="element-293" data-mp="35kr6eiadltv0">
                  {degreeCategories.map(category => <Link key={category.id} to={`/degrees/${category.id}`} className="block px-4 py-2 text-sm text-ink-secondary hover:bg-background-alt hover:text-primary" onClick={() => setIsDropdownOpen(false)} data-id="element-294" data-mp="1wfqgqe5ogye">
                      {category.name}
                    </Link>)}
                </div>}
            </div>

            <Link to="/get-matched" className="inline-flex items-center justify-center h-11 px-6 bg-primary hover:bg-primary-hover active:bg-secondary text-white font-semibold text-[15px] leading-none rounded-full shadow-ds transition-colors duration-150 ease-out focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary" data-id="element-295" data-mp="1wd61io6i5kan">
              Find My Match
            </Link>
          </nav>

          {/* Mobile menu button */}
          <div className="md:hidden flex items-center" data-id="element-296" data-mp="1cmc6pmwu6ucc">
            <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="inline-flex items-center justify-center -mr-1 p-1.5 rounded-md text-ink hover:text-primary hover:bg-background-alt focus:outline-none focus-visible:ring-2 focus-visible:ring-primary" data-id="element-297" data-mp="yq7cmzm1xgnb">
              <span className="sr-only" data-id="element-298" data-mp="2y2jjdpoc642z">Open main menu</span>
              {isMobileMenuOpen ? <XIcon className="block h-6 w-6" aria-hidden="true" data-id="element-299" data-mp="meo7vatnvpol" /> : <MenuIcon className="block h-6 w-6" aria-hidden="true" data-id="element-300" data-mp="mf69kmz3ew3w" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && <div className="md:hidden bg-surface border-b border-hairline shadow-ds" data-id="element-301" data-mp="w5j3v6wpm3n8">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3" data-id="element-302" data-mp="rd7sn7wiqvfd">
            <div className="px-3 py-2 text-xs font-semibold text-ink-muted uppercase tracking-wider" data-id="element-303" data-mp="rbwpnaawdrpb">
              All Degree Categories
            </div>
            {degreeCategories.map(category => <Link key={category.id} to={`/degrees/${category.id}`} className="block px-3 py-2 rounded-md text-base font-medium text-ink-secondary hover:text-primary hover:bg-background-alt" onClick={() => setIsMobileMenuOpen(false)} data-id="element-304" data-mp="1085pgq2sesbz">
                {category.name}
              </Link>)}

            <div className="pt-3 pb-1 px-3" data-id="element-305" data-mp="3guyrxu4jne96">
              <Link to="/get-matched" onClick={() => setIsMobileMenuOpen(false)} className="flex w-full items-center justify-center h-12 px-6 bg-primary hover:bg-primary-hover text-white font-semibold text-base leading-none rounded-full transition-colors duration-150 ease-out" data-id="element-306" data-mp="3bvvnaash7a1q">
                Find My Match
              </Link>
            </div>
          </div>
        </div>}
    </header>;
}